<template>
  <div class="background">
    <OrbitControls v-if="camera && toucher" :toucher="toucher" :camera="camera" @controls="(v) => { orbit = v; v.enableRotate = true; v.maxDistance = 2500; }" />

    <PerspectiveCamera
      :fov="75"
      :aspect="size.aspect"
      :near="1"
      :far="1000 + extraFar"
      :position="{ x: 0, y: 0, z: 500 }"
      @camera="(v) => { camera = v; }"
    />

    <Scene @scene="(v) => { scene = v }">
      <Object3D @element="(v) => { wrapper = v }">

        <!--
        <Object3D pz="10">
          <PointLight />
        </Object3D>

        <Object3D pz="0">
          <Points @element="(v) => { v.$skipRayCast = true }">
            <SphereBufferGeometry />
            <ShaderMaterial :vs="simpleVS2" :fs="simpleFS" :uniforms="animatable" />
          </Points>
        </Object3D>

        <Object3D pz="1">
          <Mesh @element="(v) => { v.onClick = onClick }">
            <SphereBufferGeometry />
            <ShaderMaterial :vs="simpleVS" :fs="simpleFS" :uniforms="animatable" />
          </Mesh>
        </Object3D>
        -->

        <!-- <Object3D :px="150" :py="160" v-if="scene">
          <Key3D :renderer="renderer" :useFresnel="false" :scene="scene" @element="(v) => { key3ds.key1 = v }" />
        </Object3D> -->

        <Object3D :px="0" :sx="kScale" :sy="kScale" :sz="kScale" :py="key3ds.position.y" v-if="scene">
          <Key3D :camera="camera" :viewBG="RS.viewBG" :texture="RS.texture" :renderer="renderer" :useFresnel="true" :scene="scene" @element="(v) => { key3ds.compo = v; setKey(); }" />
          <!-- <Key3D :camera="camera" :viewBG="RS.viewBG" :texture="RS.texture" :renderer="renderer" :useFresnel="true" :scene="scene" @element="(v) => { key3ds.compo = v; setKey() }" /> -->
        </Object3D>

        <Object3D v-if="hasPerf"
          @element="(e) => { spiralScroller = e }">
          <Object3D
            :ry="Math.PI * 0.5 * 1.3"

            :key="sfi"
            :px="160"
            :pz="-100"
            v-for="(sf, sfi) in fieldSettings"
            @element="(e) => { spiralObject3D[sfi] = e }"
            :sx="sf.sx" :sy="sf.sy" :sz="sf.sz"
          >
            <Object3D
              o-py="-200"
              :py="-650"
              :pz="-300 / 2"
            >
              <SpiralField
                @element="(e) => { spiralElements[sfi] = e }"
                :texture="sf.texture"
                :widthSeg="70 / 1.6"
                :heightSeg="50 / 1.6"
                :radius="300"
                :height="2000"
              />
            </Object3D>
          </Object3D>


        </Object3D>

        <Object3D v-if="hasPerf" @element="(e) => { bgScroller = e }">

          <Object3D
            :pz="-200"
          >
            <Object3D
              :pz="-200"
            >
              <ShootingStarsField
                :radius="800"
                :heightSeg="1"
                :widthSeg="1"
                :height="3000"
                @element="(e) => {
                  shootingStarsFieldElements[0] = e
                }"
              />
            </Object3D>
          </Object3D>

          <Object3D
            :sx="1.0"
            :sy="1.0"
            :sz="1.0"
            :py="bgInfo.position.y"
            :pz="-extraFar"
          >
            <BackgroundImage
              @element="(e) => { bg = e }"
              :width="bgInfo.size.width"
              :texture="bgImg"
            />
          </Object3D>

        </Object3D>

      </Object3D>


    </Scene>

  </div>
</template>

<script>
import Bundle from '@/components/ThreeJS/Bundle.js'
import simpleVS from '@/components/Shaders/Simple/vs.vert'
import simpleVS2 from '@/components/Shaders/Fling/vs.vert'
import simpleFS from '@/components/Shaders/Simple/fs.frag'
import * as TWEEN from '@tweenjs/tween.js'
import Dual from '@/components/Layouts/Dual.mixin.js'
import * as THREE from 'three'

import * as StarCloud from '@/components/Parts/StarCloud/StarCloud.js'
import SpiralField from '@/components/Parts/SpiralField/SpiralField.vue'
import ShootingStarsField from '@/components/Parts/ShootingStarsField/ShootingStarsField.vue'
import BackgroundImage from '@/components/Parts/BackgroundImage/BackgroundImage.vue'

// import Key3D from '@/components/Parts/Key3D/Key3D-RemixerLanding.vue'
import Key3D from '@/components/Parts/Key3D/Key3D.vue'

import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'

import * as Perf from '@/components/DOM/Perf.js'
import * as Remixer from '@/components/Pages/KeyRemixer/remixer.js'

export default {
  name: 'Background',
  mixins: [
    Dual
  ],
  props: {
    toucher: {},
    size: {},
    renderer: {},
    doc: {}
  },
  components: {
    ...Bundle,
    Key3D,
    ShootingStarsField,
    SpiralField,
    BackgroundImage
  },

  data () {
    return {
      R: Remixer,
      RS: Remixer.state,
      Math,
      wrapper: false,
      spiralScroller: false,
      bgScroller: false,
      brandKey: false,

      extraFar: 700,

      kScale: window.innerWidth < 377 ? 0.97 : 1.0,

      key3ds: {
        visible: false,
        comop: false,
        screen: {
          width: 50,
          height: 50
        },
        obj: {
          width: 50,
          height: 50
        },
        position: {
          y: 0
        }
      },

      bgInfo: {
        position: {
          y: 0
        },
        size: {
          width: 500,
          height: 500
        },
        scroll: 700
      },

      bg: false,
      cam: {
        pos: { x: 3, y: 5, z: 10 }
      },
      resizer: () => {},

      animatable: {
        time: { value: 0 }
      },

      bgImg: (window.innerWidth >= 768) ? require('./img/bg/starry-sky-1920.jpg') : require('./img/bg/starry-sky-375.jpg'),

      simpleVS,
      simpleFS,
      simpleVS2,

      // spiral vase
      fieldSettings: [
        {
          speed: 0.0015,
          texture: StarCloud.getSvg('#8a7194'),

          sx: 1.0,
          sy: 1.0,
          sz: 1.2
        },
        {
          speed: 0.0015,
          texture: StarCloud.getSvg('#e2d9c2'),

          sx: 1.0,
          sy: 1.1,
          sz: 1.2
        },
        {
          speed: 0.0015,
          texture: StarCloud.getSvg('#f2eeca'),

          sx: 1.0,
          sy: 1.2,
          sz: 1.2
        },
        {
          speed: 0.0015,
          texture: StarCloud.getSvg('#081f2c'),

          sx: 1.0,
          sy: 1.3,
          sz: 1.2
        },
        {
          speed: 0.0015,
          texture: StarCloud.getSvg('#8a7194'),

          sx: 1.0,
          sy: 1.4,
          sz: 1.2
        },
        {
          speed: 0.0015,
          texture: StarCloud.getSvg('#8a7194'),

          sx: 1.0,
          sy: 1.5,
          sz: 1.2
        }
      ],
      spiralObject3D: [],
      spiralElements: [],

      // shooting stars
      shootingStarsFieldElements: [],

      dynamicShowPercentage: 1.0,
      hasPerf: Perf.hasPerf
    }
  },
  watch: {
    bg () {
      this.setBG()
    }
  },
  computed: {
    keyCompo () {
      return this.key3ds.compo
    }
  },
  mounted () {
    var resizer = () => {
      this.setBG()
      this.setKey()
    }
    window.addEventListener('resize', resizer, false)
  },
  methods: {
    setKey () {
      if (this.key3ds.compo) {
        let mesh = this.key3ds.compo.key
        var info = this.calcInfo({ depth: mesh.position.z })

        this.RS.uniforms = mesh.material.uniforms
        this.RS.position = mesh.position

        let key3ds = this.key3ds
        let screen = key3ds.screen
        let obj = key3ds.obj
        let position = key3ds.position

        screen.width = info.screenWidth
        screen.height = info.screenHeight
        // let aspect = this.size.aspect

        this.$nextTick(() => {
          obj.height = mesh.geometry.boundingBox.max.y - mesh.geometry.boundingBox.min.y
          if (window.innerWidth < 377) {
            position.y = screen.height * 0.496 - obj.height * 5.4
          } else {
            position.y = screen.height * 0.5 - obj.height * 4.98
          }
          // obj.scroll = mesh.geometry.boundingBox.max.y - info.screenHeight
        })
      }
    },
    setBG () {
      if (this.bg) {
        let scale = 1.0
        var info = this.calcInfo({ depth: this.bg.mesh.position.z - this.extraFar })
        this.bgInfo.size.width = info.screenWidth * scale
        this.bgInfo.size.height = info.screenHeight * scale

        this.$nextTick(() => {
          this.bgInfo.position.y = -this.bg.mesh.geometry.parameters.height * scale * 0.5 + info.screenHeight * scale * 0.5
          this.bgInfo.scroll = this.bg.mesh.geometry.parameters.height * scale - info.screenHeight * scale
        })

        // this.bgInfo.position.y = -this.bg.mesh.geometry.parameters.height * 0.5 - info.screenHeight * 0.5
        //
      }
    },
    calcInfo ({ depth }) {
      var camera = this.camera
      if (camera) {
        var aspect = camera.aspect
        var dist = camera.position.z - (depth) // item
        var vFOV = THREE.Math.degToRad(camera.fov) // convert vertical fov to radians
        var screenHeight = 2 * Math.tan(vFOV / 2) * dist // visible height
        var screenWidth = screenHeight * aspect // visible width
        var ans = {
          aspect,
          dist,
          vFOV,
          screenWidth,
          screenHeight
        }
        return ans
      }
    },
    setup () {
      // this.scene.background = new THREE.Color('#000000')
      // this.scene.background = new THREE.TextureLoader().load()
      if (!Perf.hasPerf) {
        let bgImg = require('@/components/Scenes/StarSkyBg/img/bg/starry-sky-1920.jpg')
        this.renderer.domElement.style.backgroundImage = `url(${bgImg})`
        this.renderer.domElement.style.backgroundSize = `cover`
      }

      // this.scene.background = ''
      // let t = new TWEEN.Tween(this)
      //   .to({ dynamicShowPercentage: 0.0 }, 3333)
      // t.start()
    },
    onClick ({ event, intersects }) {
      // console.log(event, intersects)
      // this.$router.push('/')
      // this.$forceUpdate()
    },
    renderWebGL () {
      TWEEN.update()

      this.animatable.time.value += 0.01

      if (this.spiralObject3D) {
        this.spiralObject3D.forEach((f, fi) => {
          let speed = this.fieldSettings[fi].speed || 0.001
          let material = this.spiralElements[fi].starsMaterial

          material.uniforms.time.value = window.performance.now() * 0.001

          // if (this.$route.path === '/') {
          //   material.uniforms.opacity.value = 0.9 + 0.1 * ScrollMonitor.state.percentage * 10
          // } else {
          //   material.uniforms.opacity.value = 1.0
          // }

          // material.uniforms.showPercentage.value = this.dynamicShowPercentage

          f.rotation.y += ScrollMonitor.state.delta * 0.3
          f.rotation.y += speed

          // if (f.position.y < 800) {
          //   f.position.y += 0.1
          // }

          // if (ScrollMonitor.state.percentage < 0.25) {
          //   material.uniforms.showPercentage.value = (ScrollMonitor.state.percentage)
          // } else if (ScrollMonitor.state.percentage < 0.75) {
          //   material.uniforms.showPercentage.value = (ScrollMonitor.state.percentage * 2)
          // } else {
          //   material.uniforms.showPercentage.value = 1.0 - (-0.75 + ScrollMonitor.state.percentage)
          // }
        })
      }

      // if (this.key3ds.key1) {
      //   this.key3ds.key1.key.rotation.y += ScrollMonitor.state.delta * 2.0
      //   this.key3ds.key1.key.rotation.y += 0.005
      //   this.key3ds.key1.key.position.y = -0.25 * this.bgInfo.scroll * ScrollMonitor.state.percentage
      // }

      if (this.shootingStarsFieldElements) {
        this.shootingStarsFieldElements.forEach((el) => {
          el.starsMaterial.uniforms.time.value = window.performance.now() * 0.01 * 1.5
        })
      }

      if (this.bgScroller) {
        this.bgScroller.position.y = this.bgInfo.scroll * ScrollMonitor.state.percentage
      }

      if (this.spiralScroller) {
        this.spiralScroller.position.y = 1250 * ScrollMonitor.state.percentage
        this.spiralScroller.position.x = -160 * 2 * ScrollMonitor.state.percentage
      }

      // this.camera.position.y =

      if (this.scene && this.camera && this.renderer) {
        // this.renderer.render(this.scene, this.camera)
      }

      if (this.key3ds.compo) {
        if (this.key3ds.compo.runrun) {
          this.key3ds.compo.runrun({ wrapper: this.wrapper, visible: this.key3ds.visible })
        }
        this.key3ds.compo.key.rotation.y += ScrollMonitor.state.delta * 2.5
        this.key3ds.compo.key.rotation.y += 0.008

        let totalScroll = -0.15 * this.bgInfo.scroll
        this.key3ds.compo.key.position.y = totalScroll * ScrollMonitor.state.percentage

        // this.key3ds.compo.key.material.opacity = 1.0
        let opacity = 1.0 - (ScrollMonitor.state.percentage * 5)
        this.key3ds.compo.key.material.opacity = opacity
        // this.key3ds.compo.key.material.uniforms.opacity.value = opacity
        // this.key3ds.compo.glow.material.uniforms.opacity.value = opacity < 0 ? 0 : opacity
      }
    },
    keyRefresh (route) {
      if (route.path === '/' || route.path === '/demo/remixer2') {
        this.key3ds.visible = true
      } else {
        this.key3ds.visible = false
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    this.keyRefresh(to)
    next()
  },
  activated () {
    this.keyRefresh(this.$route)
    var self = this
    function loop (rAFT) {
      self.rAFID = window.requestAnimationFrame(loop)
      self.renderWebGL(rAFT)
    }
    self.rAFID = window.requestAnimationFrame(loop)
  },
  deactivated () {
    window.cancelAnimationFrame(this.rAFID)
    console.log('cancel animation frame')
  }
}
</script>

<style scoped>
.full{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Scenes/StarSkyBg/StarSkyBgRemixer.vue